import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import qs from 'qs'

Vue.use(Vuex)

var cancel
var CancelToken = Axios.CancelToken

export default new Vuex.Store({
  state: {
    customer: {
      email: '',
      instanceId: '',
      state: '' // new, trial or customer
    }
  },
  mutations: {
    setCustomerState (context, state) {
      context.customer.state = state
    }
  },
  actions: {
    validateEmail: (context, state) => {
      if (cancel !== undefined) {
        cancel()
      }

      return new Promise((resolve, reject) => {
        Axios.post('',
          qs.stringify({
            action: 'signupworker',
            subaction: 'checkEmail',
            customer: {
              EmailAddress: state
            },
            security: window.ajax_params.nonce
          }),
          {
            cancelToken: new CancelToken(function executor (c) {
              cancel = c
            })
          }
        )
          .then(response => {
            if (response.data.success === 1) {
              resolve(response.data)
            } else {
              reject(response.data.message)
            }
          }, response => {
            reject(response)
          })
          .catch(function (error) {
            if (Axios.isCancel(error)) {
              // Previous request was cancelled and replaced with new request
              console.log('Request canceled', error.message)
            }
          })
      })
    }
  }
})
